import Cookies from 'js-cookie'

// const TokenKey = 'OPENAUTHUSERTOKEN'
const TokenKey = 'HM_TOKEN'
const cookieOptions = {
  path: '/', // 设置为根路径，确保所有路径都能访问
  domain: '.huangheyunlan.com', // 替换为你的顶级域名，例如 .example.com
  // secure: true, // 确保使用 HTTPS
  // sameSite: 'None' //允许跨站点请求携带 Cookie。
};
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, cookieOptions)
}

export function removeToken() {
  return Cookies.remove(TokenKey, cookieOptions)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js